export default __webpack_public_path__ + "9ceebe616294e06ae34034bc8718f4e5.svg";